import Bugsnag from '@bugsnag/js';
import { PaymentMethod, PaymentMethodGrouped } from 'features/payment/interfaces';
import { PaymentMethodTypes } from '../constants';
import { errorCodes, ErrorInfo } from './error-codes';
import { HttpError } from './services/handler';

export const realoadPage = () => {
  window.location.reload();
};

export const redirecTo = (url: string) => {
  window.location.href = url;
};

export const openNewTabAndFocus = (url: string) => {
  window.open(url);
  window.focus();
};

export const handleErrorInfo = (error: HttpError): (ErrorInfo & { errorFields?: string[] }) | null => {
  let err = null;
  try {
    if (error) {
      const status = error.status;
      const errorCode = error.body?.errorCode || 0;
      const errorFields = error.body?.errorFields;
      errorCodes.GENERIC_ERROR;
      err =
        (errorCodes[status] && errorCodes[status].default) ||
        errorCodes[errorCode] ||
        (errorCodes[errorCode] && errorCodes[errorCode].default) ||
        null;
      if (err && errorFields) {
        return { ...err, errorFields };
      }
    }
    return err;
  } catch (ex) {
    return err;
  }
};

export const categorizationAndOrderedPMs = (pms: PaymentMethod[]): PaymentMethodGrouped => {
  const groups: PaymentMethodGrouped = {};
  pms.forEach(pm => {
    if (!groups[pm.type]) {
      groups[pm.type] = [];
    }
    groups[pm.type].push(pm);
  });

  // Fixed order
  const { VOUCHER, BANK_TRANSFER, CREDIT_CARD } = PaymentMethodTypes;
  return {
    ...(groups[CREDIT_CARD] ? { CREDIT_CARD: groups[CREDIT_CARD] } : {}),
    ...(groups[VOUCHER] ? { VOUCHER: groups[VOUCHER] } : {}),
    ...(groups[BANK_TRANSFER] ? { BANK_TRANSFER: groups[BANK_TRANSFER] } : {}),
  };
};

export const sendPostToShopify = (url: string) => {
  try {
    if (url) {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = url;
      document.body.appendChild(form);
      form.submit();
    }
  } catch (error) {
    Bugsnag.notify(new Error('Error in post to SHOPIFY.'));
  }
};

export const scrollToElement = (ref: any, block = 'start', behavior = 'smooth', inline = 'start') => {
  // block: start, center, end, or nearest.
  // behavior: auto or smooth.
  // inline: start, center, end or nearest.
  try {
    ref.current.scrollIntoView({ block, behavior, inline });
  } catch (ex) {
    Bugsnag.notify(new Error('ScrollIntoView: ref is null.'));
  }
};

export const getErrorKeys = (errorInfo?: ErrorInfo | null) => {
  const { level, title, keyMessage } = errorCodes.GENERIC_ERROR;
  let type = level;
  let titleKey = title;
  let messageKey = keyMessage;

  if (errorInfo) {
    type = errorInfo.level;
    titleKey = errorInfo.title;
    messageKey = errorInfo.keyMessage;
  }
  return { type, titleKey, messageKey };
};

export const getCurrentTime = () => {
  const now = new Date();
  return now.toLocaleString();
};
